module.exports = __webpack_public_path__ + "static/media/icnProxPasosEmail.8e45c1dd.svg";